import React, { useState } from "react";
import { Truck, Zap, X, Loader2 } from "lucide-react";
import { startSingleCardCheckout, startCreditPackCheckout } from "@/lib/upgrade";

/**
 * The Boutique $9.99 Pay-Per-Card checkout gate — shown when a Boutique user with 0
 * mailing_credits taps 'Print & Mail'. Includes the required 'One-Click Upgrade' hook to a
 * Credit Pack (cheaper per-card rate + permanently unlocks premium features).
 */
const BoutiqueCheckoutModal = ({ open, onClose, cardId }) => {
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");
  if (!open) return null;

  const buyOne = async () => {
    setLoading("single"); setError("");
    try {
      const r = await startSingleCardCheckout(cardId);
      if (!r.redirected) { onClose?.(); window.location.reload(); }
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not start checkout.");
      setLoading("");
    }
  };

  const buyPack = async () => {
    setLoading("pack10"); setError("");
    try {
      const r = await startCreditPackCheckout("pack10");
      if (!r.redirected) { onClose?.(); window.location.reload(); }
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not start checkout.");
      setLoading("");
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4" data-testid="boutique-checkout-modal">
      <div className="surface rounded-[2rem] p-8 max-w-sm w-full text-center relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-muted-foreground hover:text-foreground" data-testid="boutique-modal-close"><X className="w-5 h-5" /></button>
        <div className="w-14 h-14 mx-auto rounded-2xl bg-gradient-to-br from-secondary to-primary flex items-center justify-center mb-4">
          <Truck className="w-7 h-7 text-white" />
        </div>
        <h3 className="font-serif text-2xl mb-2">Send this card</h3>
        <p className="text-muted-foreground text-sm mb-5">Send this one for $9.99, or buy a 10-Card Pack for $79 ($7.90/card) — and permanently unlock every premium feature.</p>
        {error && <div className="text-xs text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2 mb-3">{error}</div>}
        <button data-testid="single-card-checkout-btn" onClick={buyOne} disabled={!!loading}
          className="w-full flex items-center justify-center gap-2 rounded-2xl py-3 text-white bg-gradient-to-r from-secondary to-primary hover:opacity-90 disabled:opacity-60 mb-2">
          {loading === "single" ? <><Loader2 className="w-4 h-4 animate-spin" /> Redirecting…</> : <>Send for $9.99</>}
        </button>
        <button data-testid="one-click-upgrade-pack-btn" onClick={buyPack} disabled={!!loading}
          className="w-full flex items-center justify-center gap-2 rounded-2xl py-3 text-primary border border-primary/30 hover:bg-primary/10 disabled:opacity-60">
          {loading === "pack10" ? <><Loader2 className="w-4 h-4 animate-spin" /> Redirecting…</> : <><Zap className="w-4 h-4" /> One-Click Upgrade — 10-Card Pack for $79</>}
        </button>
        <button onClick={onClose} className="w-full mt-2 text-xs text-muted-foreground hover:text-foreground py-1">Not now</button>
      </div>
    </div>
  );
};

export default BoutiqueCheckoutModal;
